<template>
  <div class="horizontal-scroll">
    <slot />
  </div>
</template>

<style scoped>
.horizontal-scroll {
  @apply -mx-2 px-2;
  @apply whitespace-nowrap overflow-y-scroll;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.horizontal-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}
</style>
